import { useQuery } from "@apollo/client";
import CloseIcon from "@mui/icons-material/Close";
import { Alert, Box, IconButton, Modal } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Card, Container } from "reactstrap";
import svgSortAsc from "../../svgs/arrow-up.svg";
import {GET_ALL_DUPLICATE_COMPANIES_LIST } from '../Graphql/CompanyQueries/allCompanyQuery';
import { GET_DUPLICATE_CONTACTS_LIST } from "../Graphql/ContactsQueries/contactsQuery";
import Icon from "../Icon/Icon";
import { mergingCompanyColumns, mergingContactsColumns } from '../ReactTable/Columns';
import MergingTable from '../ReactTable/MergingTable';
import ReusableSpinner from '../ReactTable/ReusableSpinner';
import SelectedMergingTable from '../ReactTable/SelectedMergingTable';

const MergingUI = () => {
  const token = localStorage.getItem("authToken");
  const url = location.href;
  const pathParts = url.split("/"); // Split the URL by '/'
  
  // Find the index of "merging" and get the next part
  const mergingIndex = pathParts.indexOf("merging");
  const moduleName = mergingIndex !== -1 ? pathParts[mergingIndex + 1] : null;
  const keywordIndex = pathParts.indexOf("company") !== -1 ? pathParts.indexOf("company") : pathParts.indexOf("contacts");

  // Extract and decode the name after "company" or "contacts"
  const extractedName = (keywordIndex !== -1 && pathParts[keywordIndex + 1]) ? decodeURIComponent(pathParts[keywordIndex + 1]) : "";
  
 
const [searchTerm, setSearchTerm] = useState(extractedName ? extractedName : "");

  const capitalizedModuleName = moduleName.charAt(0).toUpperCase() + moduleName.slice(1);
  const [selectedCells, setSelectedCells] = useState([]);

const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
const [apiData ,setApiData]= useState({})
const [isMergingwarningPopup,setIsMergingWarningPopup] = useState(false)
const [savedToastMessage,setSavedToastMessage] = useState(false)
const [sortState, setSortState] = useState([]);
useEffect(() => { //debouncing the search term
  const handler = setTimeout(() => {
    setDebouncedSearchTerm(searchTerm)
  }, 500);

  return () => clearTimeout(handler);
}, [searchTerm]); // Runs when searchTerm changes



const memoizedColumns = useMemo(() => { //handleing the columns dynamically and storing in usememo for unnecessary render issue
  return capitalizedModuleName === "Contacts" ? mergingContactsColumns : mergingCompanyColumns;
}, [capitalizedModuleName, mergingContactsColumns, mergingCompanyColumns]);


const shouldFetchContacts = capitalizedModuleName === "Contacts" && debouncedSearchTerm.length > 0; //it will skip for fetching unwanted api calls
const shouldFetchCompanies = capitalizedModuleName === "Company" && debouncedSearchTerm.length > 0; //it will skip for fetching unwanted api calls

const [apiErrorMessage,setApiErrorMessage] = useState(null)
const [duplicateErrorMessage,setDuplicateErrorMessage] = useState(null)

const { loading, error, data ,refetch } = useQuery(GET_DUPLICATE_CONTACTS_LIST, {
  skip: !shouldFetchContacts,
  variables: {name : debouncedSearchTerm ,sortOptions:sortState},
  fetchPolicy: "no-cache",
  context: { headers: { authorization: `Bearer ${token}` } },
});



const { loading: companyLoading, error: companyError, data: companyData ,refetch:companyRefetch} = useQuery(
  GET_ALL_DUPLICATE_COMPANIES_LIST,
  {
    skip: !shouldFetchCompanies,
    variables:{name : debouncedSearchTerm,sortOptions:sortState },
    fetchPolicy: "no-cache",
    context: { headers: { authorization: `Bearer ${token}` } },
  }
);


useEffect(()=>{ // after submiting the data toast message popup return and calling the api
  if (savedToastMessage) {
    const timer = setTimeout(() => {
      setSavedToastMessage(false);
      if(capitalizedModuleName === "Contacts"){
        refetch();
      }else if(capitalizedModuleName === "Company"){
        companyRefetch()
      }
      // setSelectedCells([])
    }, 2000); 

    return () => clearTimeout(timer); 
  }
  setSelectedCells([])
  
},[savedToastMessage])

useEffect(()=>{ // after submiting if api failed  toast message popup error message 
if(apiErrorMessage){
    const timer = setTimeout(() => {
      setApiErrorMessage(null);
    }, 2000); // 500ms delay
    return () => clearTimeout(timer);
  }
},[apiErrorMessage])

// useEffect(() => {
//   // Step 1: Clear previous state before updating
//   setApiData({});

//   setTimeout(() => {
//     if (capitalizedModuleName === "Contacts" && data) {
//       setApiData({
//         Agent: data.getDuplicateContacts && data.getDuplicateContacts.Agents ? data.getDuplicateContacts.Agents : [],
//         // Seller: data.getDuplicateContacts && data.getDuplicateContacts.Sellers ? data.getDuplicateContacts.Sellers : [],
//         // Buyer: data.getDuplicateContacts && data.getDuplicateContacts.Buyers ? data.getDuplicateContacts.Buyers : [],
//         "Team-Members": data.getDuplicateContacts && data.getDuplicateContacts.Teams ? data.getDuplicateContacts.Teams : [],
//         Tenant: data.getDuplicateContacts && data.getDuplicateContacts.Tenants ? data.getDuplicateContacts.Tenants : [],
//         Lender: data.getDuplicateContacts && data.getDuplicateContacts.Lenders ? data.getDuplicateContacts.Lenders : [],
//         Investors:data.getDuplicateContacts && data.getDuplicateContacts.Investors ? data.getDuplicateContacts.Investors : [],
//       });
//     } else if (capitalizedModuleName === "Company" && companyData) {
//       setApiData({
//         Firm: companyData.getAllCompanies && companyData.getAllCompanies.firms ? companyData.getAllCompanies.firms : [],
//       });
//     }
//   }, 0); // Ensures previous state clears before setting new data
// }, [data, companyData, capitalizedModuleName,savedToastMessage]);


useEffect(() => {// this will call for every submit request to assign the new apiData and render for given dependecy
  // Step 1: Clear previous state before updating
  if(capitalizedModuleName === "Contacts"){
    setApiData({
      Agent: [],
      "Team-Members": [],
      Tenant: [],
      Lender: [],
      Investors: [],
      Vendor:[]
    });
  }
  else if(capitalizedModuleName === "Company"){
    setApiData({
      Firm:[],
    })
  }
  setSelectedCells([])
  setTimeout(() => {
    if (capitalizedModuleName === "Contacts" && data) {
      setApiData({
        Investors: data.getDuplicateContacts && data.getDuplicateContacts.Investors ? data.getDuplicateContacts.Investors : [],
        Agent: data.getDuplicateContacts && data.getDuplicateContacts.Agents ? data.getDuplicateContacts.Agents : [],
          // Seller: data.getDuplicateContacts && data.getDuplicateContacts.Sellers ? data.getDuplicateContacts.Sellers : [],
        // Buyer: data.getDuplicateContacts && data.getDuplicateContacts.Buyers ? data.getDuplicateContacts.Buyers : [],
        // "Team-Members": data.getDuplicateContacts && data.getDuplicateContacts.Teams ? data.getDuplicateContacts.Teams : [], // commented this line has per jason requirment.9809
        Lender: data.getDuplicateContacts && data.getDuplicateContacts.Lenders ? data.getDuplicateContacts.Lenders : [],
        Tenant: data.getDuplicateContacts && data.getDuplicateContacts.Tenants ? data.getDuplicateContacts.Tenants : [],
        Vendor:data.getDuplicateContacts && data.getDuplicateContacts.Vendors ? data.getDuplicateContacts.Vendors : [],
       
      });
    } else if (capitalizedModuleName === "Company" && companyData) {
      setApiData({
        Firm: companyData.getDuplicateCompanies && companyData.getDuplicateCompanies.firms ? companyData.getDuplicateCompanies.firms : [],
      });
    }
  }, 0); // Ensures previous state clears before setting new data
}, [data, companyData, capitalizedModuleName,savedToastMessage]);

const getIsMergeContactIds = (selectedCells) => { // this function use for checking select is merge is ticked while sending it to delete function to popup the message
  if (selectedCells && selectedCells.isMerge && Array.isArray(selectedCells.isMerge)) {
    return selectedCells.isMerge
      .map(item => (capitalizedModuleName === "Contacts" ? item.contact_id : item.company_id))
      .filter(id => id !== undefined);
  }
  return [];
};

const isMergeContact_id = getIsMergeContactIds(selectedCells) //this code is to show the popup when is merged column deleted

const handleWarningClose = () => {
  setIsMergingWarningPopup(false);
};

const handleSort = useCallback((field, Tablekey) => {

  const type = Tablekey === "Team-Members" ? "Teams" : Tablekey || null; //new code for type

  setSortState((prevSortState) => {
    const updatedSorts = [...prevSortState];
    const existingIndex = updatedSorts.findIndex(
      (item) => item.type === type && item.field === field
    );

    if (existingIndex === -1) {
      return [...updatedSorts, { type, field, order: "asc" }];
    }

    const existing = updatedSorts[existingIndex];

    if (existing.order === "asc") {
      updatedSorts[existingIndex] = { ...existing, order: "desc" };
    } else if (existing.order === "desc") {
      updatedSorts.splice(existingIndex, 1);
    }

    return updatedSorts;
  });
}, [sortState]); // You can add dependencies here as needed


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setSortState([])
  };

  const handleClear = () => {
    setSelectedCells([]);
    setSearchTerm("");
    setSortState([])
    // setApiData(statitcData)
    // setSelectedCategory("Contacts")
  };

  return (
    <div className="page-rounded-corner-container">
      <div className="page-header-container list">
        <div
          className="page-back-button"
          onClick={() => {
            // handleNavigation()
            // history.back();
              const baseUrl = location.origin;
               const url = `${baseUrl}/${capitalizedModuleName}`;
             window.location.href = url;
          }}
        >
          <Icon svg={svgSortAsc} />
          {moduleName === "contacts" ? "contacts" : "company"}
        </div>
        <div className="page-header list">
          <div className="page-title" style={{ marginTop: "10px" }}>
            CRM Merging {capitalizedModuleName}
          </div>
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm || ""}
            onChange={handleSearchChange}
            style={{
              marginLeft:"2px",
              width: "200px", // Increased width for better readability
              padding: "6px 10px", // Added padding for better spacing
              marginTop: "10px",
              backgroundColor: "white",
              fontFamily: "monospace",
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
              border: "1px solid #ccc", // Soft border
              borderRadius: "4px", // Smooth rounded corners
              outline: "none", // Removes blue outline on focus
            }}
            title={searchTerm || ""} // Tooltip with full text
          />

          <button
            className="button-new negative margin-left"
            onClick={handleClear}
            disabled={!searchTerm}
            style={{ marginTop: "10px", marginLeft:"6px"}}
          >
            Clear
          </button>
        </div>
        <div className="line" />
      </div>
      <div className="page-body-container crud">
        <div
          style={{
            position: "sticky",
            top: "60px",
            zIndex: 1000,
            background: "white",
            // marginRight: "-75px",
            marginLeft: "4px",
          }}
        >
          <Container
            style={{
              maxWidth: "1928px",
              padding: "0",
              borderRadius: "12px", // ✅ Add rounded corners
              overflow: "hidden", // ✅ Ensures corners stay rounded
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // ✅ Adds a subtle shadow for better UI
            }}
          >
            <Card
              style={{
                marginBottom: "10px",
                // padding: "16px",
                // marginTop: "16px",
                // marginLeft: "0", // Remove extra margin on the left
                marginTop: "7px",
                marginLeft: "18px", // Remove extra margin on the left
              }}
            >
              <SelectedMergingTable
                selectedCells={selectedCells}
                setSelectedCells={setSelectedCells}
                debouncedSearchTerm={debouncedSearchTerm}
                capitalizedModuleName={capitalizedModuleName}
                setSavedToastMessage={setSavedToastMessage}
                setApiErrorMessage={setApiErrorMessage}
                apiErrorMessage={apiErrorMessage}
                savedToastMessage={savedToastMessage}
                setDuplicateErrorMessage={setDuplicateErrorMessage}
                duplicateErrorMessage={duplicateErrorMessage}
                memoizedColumns={memoizedColumns}
              />
            </Card>
          </Container>
        </div>
        {debouncedSearchTerm.length > 0 && (loading || companyLoading) ? (
          // <p>Loading...</p>
          <ReusableSpinner />
        ) : (
          debouncedSearchTerm.length > 0 &&
          Object.keys(apiData).map((key) => (
            <div key={key} style={{ marginBottom: "40px" }}>
              <MergingTable
                tableColumns={memoizedColumns[key]}
                tableData={apiData[key]}
                selectedCells={selectedCells}
                setSelectedCells={setSelectedCells}
                debouncedSearchTerm={debouncedSearchTerm}
                setApiData={setApiData}
                apiData={apiData}
                Tablekey={key}
                isMergeContact_id={isMergeContact_id}
                setIsMergingWarningPopup={setIsMergingWarningPopup}
                capitalizedModuleName={capitalizedModuleName}
                sortState={sortState} 
                setSortState={setSortState}
                handleSort={handleSort}
              />
            </div>
          ))
        )}
      </div>
      <Modal
        open={isMergingwarningPopup}
        onClose={handleWarningClose}
        aria-labelledby="info-alert"
        closeAfterTransition
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
            minWidth: 300,
          }}
        >
          <Alert
            severity="info"
            action={
              <IconButton
                size="small"
                color="inherit"
                onClick={handleWarningClose}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            }
          >
            Please unselect the merge before deleting.
          </Alert>
        </Box>
      </Modal>
    </div>
  );
};

export default React.memo(MergingUI);
